import { toHaveStyle } from '@testing-library/jest-dom/dist/matchers';
import React, { Component } from 'react';
import {RegWrapper} from './RegWrapper.js';
import axios from 'axios'
import validator from 'validator';
import {Loader} from './Loader.js';

export class PassCreator extends Component {

    state = {
        pass1 : '',
        pass2 : '',
        success: null,
        
        showErrorMsg : false,
        errorMsg : null,
        isSending: false,
        inputErrorMessage : null //'Пароли не совпадают'
    }
    constructor(props) {
        super(props)
        this.props = props 
    }

    updatePass1 = (e) => {
        const updatedInputValue = e.target.value;
        // ...
        
        this.setState((prevState) => {
             return  {
                    ...prevState,
                    pass1 : updatedInputValue,
                    inputErrorMessage : null
                
                };
        }, () =>  {
            
        })
    
    }

    updatePass2 = (e) => {
        const updatedInputValue = e.target.value;
        // ...
        
        this.setState((prevState) => {
             return  {
                    ...prevState,
                    pass2 : updatedInputValue,
                    inputErrorMessage : null
                
                };
        }, () =>  {
            
        })
    
    }

    sendRequest = (e) => {

        if (this.state.pass1  != this.state.pass2) {
            
            this.setState((prevState) => {
                return  {
                        ...prevState,
                        inputErrorMessage : 'Пароли не совпадают'
                   
                   };
           }, () =>  {
               
           })
            return
        }
        // this.state.pass1
        if ( !validator.isStrongPassword(this.state.pass1, {
            minLength: 8,  minNumbers: 0, minSymbols: 0, minLowercase: 0, minUppercase: 0
          }) ) { 
            
            this.setState((prevState) => {
                return  {
                        ...prevState,
                        inputErrorMessage : 'Пароль должен содержать не менее 8 символов'
                   
                   };
           }, () =>  {
               
           })
            return

        }
        
        this.setState((prevState) => {
            return  {
                   ...prevState,
                  
                   isSending: true
               };
       }, () =>  {
           
       })
        axios
        .post(process.env.REACT_APP_BACKEND_SERVER + '/PasswordChangeConfirm/', {
            'pas1' : this.state.pass1,
            
            'pas2' :  this.state.pass2,
            'token' : this.props.match.params.token
         },
        /* {headers: {
            'Content-Type': 'multipart/form-data'
        }}*/ )
        .then(res => {
            /* alert(res.data) */
            if (res.data.status == 'ok') {
                this.setState((prevState) => {
                    return  {
                           ...prevState,
                           success : true,
                           isSending: false
                       };
               }, () =>  {
                   
               })
            }
            
            
            
        })
        .catch(err => {
            this.setState((prevState) => {
                return  {
                       ...prevState,
                       
                       isSending: false
                   };
           }, () =>  {
               
           })
            alert('error')

        })
    }


    redirect = (e) => {
        window.location.href = '/auth'
    }

    componentDidUpdate() {
        // alert('ddffsg')

        if (this.state.success === true) {
            window.location.href = '/auth'
        }
    }

    
    render() {
        return (
            
        <RegWrapper  errorMsg={this.state.errorMsg} showErrorMsg={this.state.showErrorMsg}>
            <Loader loader={this.state.isSending} />
            <>{
                this.state.success === null ? 
                <div>
                    <div><h1>Сменить пароль</h1></div>
                    <div className="uk-margin">
                        <input className={
                            this.state.inputErrorMessage == null ? 
                            "uk-input uk-form-width-large uk-form-large uk-background-muted"
                            :
                            "uk-input uk-form-width-large uk-form-large uk-background-muted error_input"
                        }
                        
                        type="password" placeholder="Новый пароль*" value={this.state.pass1}
                        onChange={e => this.updatePass1(e)}/>
                        
                    </div>
                    <div className="uk-margin">
                        <input className={
                            this.state.inputErrorMessage == null ? 
                            "uk-input uk-form-width-large uk-form-large uk-background-muted"
                            :
                            "uk-input uk-form-width-large uk-form-large uk-background-muted error_input"
                        }
                        type="password" placeholder="Новый пароль повтор*" value={this.state.pass2}
                        onChange={e => this.updatePass2(e) }/>
                        <div className='input_error'> {this.state.inputErrorMessage} </div> 
                    </div>
                    
                    <div class="main-left-bottom">
                        <button onClick={ e => this.sendRequest(e)} class="btn1">Сохранить</button>
                    </div>
                </div>
                 : null
            } </> 

            {/* <>{
                this.state.success === true ? 
                
                redirect() : null
            } </> */ } 

            <>{
                this.state.success === false ? 
                <h1> Не получилось </h1>
                 : null
            } </> 

        </RegWrapper>  

        )
    }

}